// src/redux/actions.js
import { FETCH_ORGANIZATION_FAILURE, FETCH_ORGANIZATION_REQUEST, FETCH_ORGANIZATION_SUCCESS } from "../redux/actionTypes";
import {
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAILURE,

  SET_DATE,
  FETCH_REALTIME_LINE_ACTIVITY_REQUEST,
  FETCH_REALTIME_LINE_ACTIVITY_SUCCESS,
  FETCH_REALTIME_LINE_ACTIVITY_FAILURE,
  REAL_TIME_LINE_ACTIVITY_NON_SEED_REQUEST,
  REAL_TIME_LINE_ACTIVITY_NON_SEED_SUCCESS,
  REAL_TIME_LINE_ACTIVITY_NON_SEED_FAILURE,

  FETCH_REALTIME_WAREHOUSE_ACTIVITY_REQUEST,
  FETCH_REALTIME_WAREHOUSE_ACTIVITY_SUCCESS,
  FETCH_REALTIME_WAREHOUSE_ACTIVITY_FAILURE,
  FETCH_REALTIME_WAREHOUSE_LINE_REQUEST,
  FETCH_REALTIME_WAREHOUSE_LINE_SUCCESS,
  FETCH_REALTIME_WAREHOUSE_LINE_FAILURE,
  FETCH_REALTIME_WAREHOUSE_COUNT_REQUEST,
  FETCH_REALTIME_WAREHOUSE_COUNT_SUCCESS,
  FETCH_REALTIME_WAREHOUSE_COUNT_FAILURE,

  DRIER_STATUS_REQUEST,
  DRIER_STATUS_SUCCESS,
  DRIER_STATUS_FAILURE,
  FETCH_DRIER_STATUS_REPORT_ODD_FAILURE,
  FETCH_DRIER_STATUS_REPORT_ODD_SUCCESS,
  FETCH_DRIER_STATUS_REPORT_ODD_REQUEST,
  FETCH_DRIER_STATUS_REPORT_EVEN_FAILURE,
  FETCH_DRIER_STATUS_REPORT_EVEN_SUCCESS,
  FETCH_DRIER_STATUS_REPORT_EVEN_REQUEST,

  FETCH_WAREHOUSE_STATUS_REQUEST,
  FETCH_WAREHOUSE_STATUS_SUCCESS,
  FETCH_WAREHOUSE_STATUS_FAILURE,
  FETCH_WAREHOUSE_STATUS_LINE_SEED_REQUEST,
  FETCH_WAREHOUSE_STATUS_LINE_SEED_SUCCESS,
  FETCH_WAREHOUSE_STATUS_LINE_SEED_FAILURE,
  FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_REQUEST,
  FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_SUCCESS,
  FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_FAILURE,
  FETCH_DRYING_TRANSACTION_TEMP_REQUEST,
  FETCH_DRYING_TRANSACTION_TEMP_SUCCESS,
  FETCH_DRYING_TRANSACTION_TEMP_FAILURE,

} from "./actionTypes";

export const fetchDataRequest = () => ({
  type: FETCH_DATA_REQUEST,
});

export const fetchDataSuccess = (data) => ({
  type: FETCH_DATA_SUCCESS,
  payload: data,
});

export const fetchDataFailure = (error) => ({
  type: FETCH_DATA_FAILURE,
  payload: error,
});

export const setDate = (date) => ({
  type: SET_DATE,
  payload: date,
});

export const fetchRealTimeLineActivityRequest = () => ({
  type: FETCH_REALTIME_LINE_ACTIVITY_REQUEST,
});

export const fetchRealTimeLineActivitySuccess = (data) => ({
  type: FETCH_REALTIME_LINE_ACTIVITY_SUCCESS,
  payload: data,
});

export const fetchRealTimeLineActivityFailure = (error) => ({
  type: FETCH_REALTIME_LINE_ACTIVITY_FAILURE,
  payload: error,
});

export const realTimeLineActivityNonSeedRequest = () => ({
  type: REAL_TIME_LINE_ACTIVITY_NON_SEED_REQUEST,
});

// Action to handle success
export const realTimeLineActivityNonSeedSuccess = (data) => ({
  type: REAL_TIME_LINE_ACTIVITY_NON_SEED_SUCCESS,
  payload: data,
});

// Action to handle failure
export const realTimeLineActivityNonSeedFailure = (error) => ({
  type: REAL_TIME_LINE_ACTIVITY_NON_SEED_FAILURE,
  payload: error,
});

export const fetchRealTimeWarehouseActivityRequest = () => ({
  type: FETCH_REALTIME_WAREHOUSE_ACTIVITY_REQUEST,
});

export const fetchRealTimeWarehouseActivitySuccess = (data) => ({
  type: FETCH_REALTIME_WAREHOUSE_ACTIVITY_SUCCESS,
  payload: data,
});

export const fetchRealTimeWarehouseActivityFailure = (error) => ({
  type: FETCH_REALTIME_WAREHOUSE_ACTIVITY_FAILURE,
  payload: error,
});
// 📌 Warehouse Line Actions
export const fetchRealTimeWarehouseLineRequest = () => ({
  type: FETCH_REALTIME_WAREHOUSE_LINE_REQUEST,
});

export const fetchRealTimeWarehouseLineSuccess = (data) => ({
  type: FETCH_REALTIME_WAREHOUSE_LINE_SUCCESS,
  payload: data,
});

export const fetchRealTimeWarehouseLineFailure = (error) => ({
  type: FETCH_REALTIME_WAREHOUSE_LINE_FAILURE,
  payload: error,
});

// 📌 Warehouse Count Actions
export const fetchRealTimeWarehouseCountRequest = () => ({
  type: FETCH_REALTIME_WAREHOUSE_COUNT_REQUEST,
});

export const fetchRealTimeWarehouseCountSuccess = (data) => ({
  type: FETCH_REALTIME_WAREHOUSE_COUNT_SUCCESS,
  payload: data,
});

export const fetchRealTimeWarehouseCountFailure = (error) => ({
  type: FETCH_REALTIME_WAREHOUSE_COUNT_FAILURE,
  payload: error,
});

export const fetchDrierStatusRequest = () => ({
  type: DRIER_STATUS_REQUEST,
});

export const fetchDrierStatusSuccess = (data) => ({
  type: DRIER_STATUS_SUCCESS,
  payload: data,
});

export const fetchDrierStatusFailure = (error) => ({
  type: DRIER_STATUS_FAILURE,
  payload: error,
});

export const fetchDrierStatusReportEvenRequest = () => ({
  type: FETCH_DRIER_STATUS_REPORT_EVEN_REQUEST,
});

export const fetchDrierStatusReportEvenSuccess = (data) => ({
  type: FETCH_DRIER_STATUS_REPORT_EVEN_SUCCESS,
  payload: data,
});

export const fetchDrierStatusReportEvenFailure = (error) => ({
  type: FETCH_DRIER_STATUS_REPORT_EVEN_FAILURE,
  error,
});

// Action Creators for Odd Drier Status Report
export const fetchDrierStatusReportOddRequest = () => ({
  type: FETCH_DRIER_STATUS_REPORT_ODD_REQUEST,
});

export const fetchDrierStatusReportOddSuccess = (data) => ({
  type: FETCH_DRIER_STATUS_REPORT_ODD_SUCCESS,
  payload: data,
});

export const fetchDrierStatusReportOddFailure = (error) => ({
  type: FETCH_DRIER_STATUS_REPORT_ODD_FAILURE,
  error,
});


export const fetchDryingTransactionTempRequest = () => ({
  type: FETCH_DRYING_TRANSACTION_TEMP_REQUEST,
});

export const fetchDryingTransactionTempSuccess = (data) => ({
  type: FETCH_DRYING_TRANSACTION_TEMP_SUCCESS,
  payload: data,
});

export const fetchDryingTransactionTempFailure = (error) => ({
  type: FETCH_DRYING_TRANSACTION_TEMP_FAILURE,
  error,
});




export const fetchWarehouseStatusRequest = () => ({
  type: FETCH_WAREHOUSE_STATUS_REQUEST,
});

export const fetchWarehouseStatusSuccess = (data) => ({
  type: FETCH_WAREHOUSE_STATUS_SUCCESS,
  payload: data,
});

export const fetchWarehouseStatusFailure = (error) => ({
  type: FETCH_WAREHOUSE_STATUS_FAILURE,
  payload: error,
});

// Seed Actions
export const fetchWarehouseStatusLineSeedRequest = () => ({
  type: FETCH_WAREHOUSE_STATUS_LINE_SEED_REQUEST,
});

export const fetchWarehouseStatusLineSeedSuccess = (data) => ({
  type: FETCH_WAREHOUSE_STATUS_LINE_SEED_SUCCESS,
  payload: data,
});

export const fetchWarehouseStatusLineSeedFailure = (error) => ({
  type: FETCH_WAREHOUSE_STATUS_LINE_SEED_FAILURE,
  payload: error,
});

// Non-Seed Actions
export const fetchWarehouseStatusLineNonSeedRequest = () => ({
  type: FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_REQUEST,
});

export const fetchWarehouseStatusLineNonSeedSuccess = (data) => ({
  type: FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_SUCCESS,
  payload: data,
});

export const fetchWarehouseStatusLineNonSeedFailure = (error) => ({
  type: FETCH_WAREHOUSE_STATUS_LINE_NON_SEED_FAILURE,
  payload: error,
});
export const resetReportState = () => ({
  type: 'RESET_REPORT_STATE',
});

// fetch org
export const fetchOrganizationRequest = () => ({
  type: FETCH_ORGANIZATION_REQUEST,
});

export const fetchOrganizationSuccess = (data) => ({
  type: FETCH_ORGANIZATION_SUCCESS,
  payload: data,
});

export const fetchOrganizationFailure = (error) => ({
  type: FETCH_ORGANIZATION_FAILURE,
  payload: error,
});